'use strict'

var Marionette = require('marionette'),
  Backbone = require('backbone'),
  App = require('app'),
  _ = require('lodash'),
  Constants

/**
 *
 */
Constants = {
  siUnits: {
    voltage: ['mV', 'V', 'kV'],
    current: ['mA', 'A', 'kA'],
    power: ['mW', 'W', 'kW', 'MW', 'GW'],
    energy: ['Wh', 'kWh', 'MWh', 'GWh', 'TWh', 'PWh'],
    mass: ['g','kg','Mg','Gg','Tg','Pg'],
    parts: ['ppm', 'ppb', 'ppt', 'ppq' ],
    frequency: ['mHz', 'Hz', 'kHz', 'MHz', 'THz']
  },
  // /* permissions */
  // errorCodes: {
  //
  //   AUTH_FAILED: 10,
  //   AUTH_UNKNOWN_USER: 11,
  //   AUTH_WRONG_PASSWORD: 12,
  //   AUTH_INVALID_TOKEN: 13,
  //
  //   AUTH_TOKEN_INVALID: 21,
  //   AUTH_TOKEN_INVALID_USER: 22
  // },
  text: {
    CONFIRM_PRESET_APPLY_DEVICE: 'Are you sure you want to override the Sensors and Properties settings?',
    PROMPT_PRESET_NAME: 'Please enter a preset name',
    NOTICE_PRESET_SAVED: 'Preset saved',
    NOTICE_SAVE_FAILED: 'Preset save failed',
    CONFIRM_SURE_DELETE: 'Are you sure you want to delete <%= name %>?',
    CONFIRM_BULK_DELETE: 'Are you sure you want to perform a bulk delete?',
    NOTICE_BULK_DEVICETYPE: 'To perform a bulk control, all selected devices need to be of the same type.',
    NOTICE_COMMAND_SENT: 'The command has been successfully queued.'
  },
  /** Device options */
  dimLevels: [
    0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100
  ],
  rgbColors: [
    {label: 'No color',       hex: '0'     },
    {label: 'Lavendel White', hex: '4C4C4C'},
    {label: 'Sun Yellow',     hex: '5A5A00'},
    {label: 'Scarlet Red',    hex: '5A005A'},
    {label: 'Sky Blue',       hex: '0000B2'},
    {label: 'Eco Green',      hex: '00B200'},
    {label: 'Ocean Blue',     hex: '005A5A'},
    {label: 'Evening Red',    hex: 'B20000'},
    {label: 'Royal Orange',   hex: 'FF1400'}
  ],
  /** Device Types */
  deviceTypes: [
      { label: 'IRD',                  id: 'ird_driver',       routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM-RC',               id: 'rtm_rc',           routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM-IO',               id: 'rtm_io',           routineType: 'day', legacyTimeOffset: true },    
      { label: 'RTM-NF-DIAG',          id: 'rtm_nf_diag',      routineType: 'day', legacyTimeOffset: true },
      { label: 'RGB',                  id: 'rgb_driver',       routineType: 'day', legacyTimeOffset: true },
      { label: 'IRD-RGB',              id: 'ird_rgb_driver',   routineType: 'day', legacyTimeOffset: true },
      { label: 'Energy Node',          id: 'energy_node',      routineType: 'day', legacyTimeOffset: true },
      { label: 'Parking Node',         id: 'parking_node',     routineType: 'day', legacyTimeOffset: true },   
      { label: 'RTM-SENSORHOTEL',      id: 'rtm_sensorhotel',  routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_PIR_NB_IOT',       id: 'rtm_pir_nb_iot',   routineType: 'day', legacyTimeOffset: true },   
      { label: 'RTM_SMARTCARE',        id: 'rtm_smartcare',    routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_LC',               id: 'rtm_lc',           routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_RHM',              id: 'rtm_rhm',          routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_RHM_MQTT',         id: 'rtm_rhm_mqtt',     routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_ZSC',              id: 'rtm_zsc',          routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_ZSC_V1',           id: 'rtm_zsc_v1',       routineType: 'week',  hasAssetData:true },
      { label: 'RTM_DALI_X',           id: 'rtm_dali_x',       routineType: 'week',  hasAssetData:true },
      { label: 'RTM_ZSC_100',          id: 'rtm_zsc_100',       routineType: 'week', hasAssetData:true },
      { label: 'RTM_ZSC_F',            id: 'rtm_zsc_f',        routineType: 'week', hasAssetData:true },
      { label: 'RTM_ZSC_R',            id: 'rtm_zsc_r',        routineType: 'week', hasAssetData:true },
      { label: 'RTM_ZSC_S',            id: 'rtm_zsc_s',        routineType: 'week' },
      { label: 'RTM_ZSC_RGBW',         id: 'rtm_zsc_rgbw' ,    routineType: 'day' },
      { label: 'RTM_ZSC_130',          id: 'rtm_zsc_130' ,    routineType: 'day' },
      { label: 'RTM_AFD',              id: 'rtm_afd',          routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_GPS_TRACKER',      id: 'rtm_gpstracker',   routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_DYNACONTROLLER',   id: 'rtm_dyn',          routineType: 'day', legacyTimeOffset: true },
      { label: 'RTM_DYNACONTROLLER_B', id: 'rtm_dyn_b',        routineType: 'day', legacyTimeOffset: true },

      /*
      {label: 'RTM10-RT', id: 'rtm10_rt'},
      {label: 'RTM10-RT-DC', id: 'rtm10_rt_dc'},
      {label: 'RTM10-RTX', id: 'rtm10_rtx'},
      {label: 'RTM10-RTX-DC', id: 'rtm10_rtx_dc'},
      {label: 'RTM20-RT', id: 'rtm20_rt'},
      {label: 'RTM20-RTX', id: 'rtm20_rtx'},
      {label: 'RTM20-RTX-DC', id: 'rtm20_rtx_dc'},
*/
      {label: 'Gateway', id: 'gateway'}
  ],
  /** Reset Reasons */
  resetReasons: [
    { label: 'NONE',           id: 0 },
    { label: 'SYS_HW',         id: 1 },
    { label: 'SYS_SW',         id: 2 },
    { label: 'WATCHDOG_W',     id: 3 }, 
    { label: 'WATCHDOG_I',     id: 4 },
    { label: 'LOCKUP',         id: 5 },
    { label: 'BOR',            id: 6 },
    { label: 'POR',            id: 7 },
    { label: 'IO',             id: 8 },
    { label: 'TIMER',          id: 9 },
  ]
}

module.exports = Constants



// WEBPACK FOOTER //
// ./js/common/app-constants.js